import { render, staticRenderFns } from "./PermissionsManagerModal.vue?vue&type=template&id=3ee30120&scoped=true"
import script from "./PermissionsManagerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionsManagerModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PermissionsManagerModal.vue?vue&type=style&index=0&id=3ee30120&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee30120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee30120')) {
      api.createRecord('3ee30120', component.options)
    } else {
      api.reload('3ee30120', component.options)
    }
    module.hot.accept("./PermissionsManagerModal.vue?vue&type=template&id=3ee30120&scoped=true", function () {
      api.rerender('3ee30120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PermissionsManagerModal.vue"
export default component.exports